import { Model, attr } from 'redux-orm';

const defaultAttributes = {
  tenant: 'Default tenant'
};

export default class Tenants extends Model {
  static modelName = 'Tenants';

  static fields = {
    tenant: attr()
  };

  static parse(data) {
    return this.upsert(data);
  }

  static generate(newAttributes = {}) {
    const combinedAttributes = {
      ...defaultAttributes,
      ...newAttributes
    };

    return this.create(combinedAttributes);
  }

  toJSON() {
    return { ...this.ref };
  }

  updateFrom(otherView) {
    this.update(otherView.ref);
  }
}
